<template>
  <div class="layout-container">
    <Sidebar />
    <div class="main-container" :class="[isCollapse ? 'isCollapse' : '']">
      <Navbar />
      <TagsView />
      <AppMain />
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { Sidebar, Navbar, TagsView, AppMain } from "./components";
export default {
  components: {
    Sidebar,
    Navbar,
    TagsView,
    AppMain,
  },
  computed: {
    ...mapState("layout", ["isCollapse"]),
  },
};
</script>
<style lang="less" scoped>
.layout-container {
  width: 100%;
  height: 100%;
  .main-container {
    position: relative;
    height: 100%;
    margin-left: 260px;
    background-color: #fff;
    transition: all 0.28s ease;
    &.isCollapse {
      margin-left: 64px;
    }
  }
}
</style>